// @vendors
const moment = require('moment');

// @utilities
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { DATE_FORMAT_TIME_HORIZON_CHECK } = require('../raConstants/index');

const portfolioEvolutionSuccess = data => ({
    type: actionTypes.RA_OBJ_TRACKING_EVOLUTION_SUCCESS,
    payload: { data },
});

const portfolioEvolutionFailure = error => ({
    type: actionTypes.RA_OBJ_TRACKING_EVOLUTION_FAILURE,
    payload: { error },
});

const portfolioEvolutionInProgress = () => ({
    type: actionTypes.RA_OBJ_TRACKING_EVOLUTION_REQUEST,
});

const portfolioEvolutionChangeOption = value => ({
    type: actionTypes.RA_OBJ_TRACKING_EVOLUTION_CHANGE_OPTION,
    payload: { value },
});

const requestPortfolioEvolutionChart = (
    portfolioId,
    portfolioStartDate,
) => dispatch => {
    const params = {
        portfolioId,
    };
    const requestData = {
        query: {
            startDate: moment(portfolioStartDate).format(
                DATE_FORMAT_TIME_HORIZON_CHECK,
            ),
        },
    };

    dispatch(portfolioEvolutionInProgress());
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('raObjectiveTrackingEvolutionChart', params),
        requestData,
    )
        .then(response => {
            dispatch(portfolioEvolutionSuccess(response));
        })
        .catch(error => {
            if (error.error) {
                dispatch(portfolioEvolutionFailure(error));
            } else {
                throw error;
            }
        });
};

module.exports = {
    requestPortfolioEvolutionChart,
    portfolioEvolutionChangeOption,
};
